/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Filter: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.7787 1.52L10.0887 7V14.89C10.0887 16 9.44866 16.27 8.67766 15.491L6.78866 13.611C6.39866 13.22 6.08866 12.451 6.08866 11.901V7L1.38766 1.52C0.668661 0.68 0.978661 0 2.07866 0H14.0887C15.1887 0 15.4987 0.68 14.7787 1.52Z'
			/>
		</Svg>
	);
};

export { Filter };
